import React from "react";
import { Helmet } from "react-helmet";

function SSoft_Solution_FM_Seo() {
  return (
    <Helmet>
      {/* ==== TITLE & DESCRIPTION ==== */}
      <title>
        Infor SunSystems Indonesia | Accounting & Financial Management Software
        - PT Supersoft Sistemindo
      </title>
      <meta
        name="description"
        content="Kelola keuangan perusahaan dengan Infor SunSystems. Solusi accounting system, financial software, dan sistem akuntansi Indonesia dari PT Supersoft Sistemindo, partner resmi Infor."
      />
      <meta
        name="keywords"
        content="
          accounting system jakarta,
          accounting system indonesia,
          software akuntansi jakarta,
          software akuntansi indonesia,
          sistem akuntansi indonesia,
          system akuntansi jakarta,
          sistem finansial,
          financial system,
          accounting system,
          financial software,
          accounting software,
          Infor SunSystems,
          PT Supersoft Sistemindo
        "
      />
      <link
        rel="canonical"
        href="https://ptsupersoft.com/solutions/financial-management"
      />

      {/* ==== OPEN GRAPH ==== */}
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content="https://ptsupersoft.com/solutions/financial-management"
      />
      <meta
        property="og:title"
        content="Infor SunSystems Indonesia | Accounting & Financial Management Software"
      />
      <meta
        property="og:description"
        content="Infor SunSystems membantu perusahaan mengelola keuangan, laporan, dan analisis multi-entitas. PT Supersoft Sistemindo menyediakan lisensi dan implementasi resmi di Indonesia."
      />
      <meta
        property="og:image"
        content="https://bzpublishassets.blob.core.windows.net/media/assets/sunsystems_banner.png"
      />

      {/* ==== AI SEARCH OPTIMIZATION ==== */}
      <meta
        name="ai-keywords"
        content="
          accounting system jakarta,
          accounting system indonesia,
          software akuntansi jakarta,
          software akuntansi indonesia,
          sistem akuntansi indonesia,
          system akuntansi jakarta,
          sistem finansial,
          financial system,
          accounting system,
          financial software,
          accounting software,
          Infor SunSystems,
          PT Supersoft Sistemindo
        "
      />
      <meta
        name="ai-summary"
        content="Infor SunSystems adalah solusi Financial Management dan accounting system untuk perusahaan Indonesia. PT Supersoft Sistemindo menyediakan lisensi dan implementasi resmi di Indonesia untuk mengelola laporan, multi-entitas, dan analisis keuangan secara efisien."
      />

      {/* ==== FAQ SCHEMA ==== */}
      <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Apa itu Infor SunSystems?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Infor SunSystems adalah sistem manajemen keuangan terintegrasi untuk perusahaan dengan multi-entitas dan multi-mata uang. PT Supersoft Sistemindo adalah partner resmi Infor di Indonesia."
            }
          },
          {
            "@type": "Question",
            "name": "What is Infor SunSystems?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Infor SunSystems is an integrated financial management system for companies with multi-entity and multi-currency support. PT Supersoft Sistemindo provides licensing and implementation in Indonesia."
            }
          },
          {
            "@type": "Question",
            "name": "Apa manfaat utama Infor SunSystems?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Memberikan visibilitas finansial real-time, integrasi laporan otomatis, dan efisiensi pelaporan lintas entitas bisnis."
            }
          }
        ]
      }
      `}</script>

      {/* ==== SOFTWARE APPLICATION SCHEMA ==== */}
      <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "Infor SunSystems Financial Management",
        "applicationCategory": "BusinessApplication",
        "operatingSystem": "Web",
        "url": "https://ptsupersoft.com/solutions/financial-management",
        "description": "Solusi accounting system dan financial software untuk perusahaan di Jakarta dan Indonesia. PT Supersoft Sistemindo menyediakan lisensi dan implementasi resmi Infor SunSystems.",
        "softwareVersion": "Latest",
        "keywords": [
          "accounting system jakarta",
          "accounting system indonesia",
          "software akuntansi jakarta",
          "software akuntansi indonesia",
          "sistem akuntansi indonesia",
          "system akuntansi jakarta",
          "sistem finansial",
          "financial system",
          "accounting system",
          "financial software",
          "accounting software"
        ],
        "provider": {
          "@type": "Organization",
          "name": "PT Supersoft Sistemindo",
          "url": "https://ptsupersoft.com"
        }
      }
      `}</script>
    </Helmet>
  );
}

export default SSoft_Solution_FM_Seo;
